import { type Network } from 'hb-react/types';

export const getPageTitleFromNetwork = (network?: Network) =>
  network?.page_title || network?.title;
